import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets }: Theme) => ({
    noPasses: {
        fontFamily: typographyPresets.fonts.monserrat.regular,
        fontSize: 12,
    },
}))
